<template>
    <div v-if="!hide"  class="form-network form-network-facebook">
        <details v-if="hasPersonalConciergeriePage" open>
            <summary>{{ $t('dash.post-creator.form.facebook.privacy') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <SelectComponent 
                    :valueSelect="formDataNetwork.visibility" 
                    :changeValueSelect="changeVisibilityPost" 
                    :data="{
                        EVERYONE: $t('dash.post-creator.form.facebook.visibility-public'), 
                        FRIENDS: $t('dash.post-creator.form.facebook.visibility-friends'),
                        SELF: $t('dash.post-creator.form.facebook.visibility-me')
                    }"  
                    :positionAuto="false" 
                    :positionX="'left'"
                />
            </div>
        </details>
        <details open>
            <summary>{{ $t('dash.post-creator.form.facebook.visibility') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="list-simple-btn">
                    <div class="type-btn-simple" @click="addMode('addPlaceMode')">
                        <i class="fa-solid fa-map-pin"></i>
                        <p>
                            {{ $t('dash.post-creator.form.facebook.place') }} 
                            <span class="pink">({{ draftInstance.form.networks.facebook.place ? '1' : '0' }})</span>
                        </p>
                    </div>    
                </div>         
            </div>      
        </details>
        <details v-if="draftInstance.form.urlsTextContentHistory.length" open>
            <summary>
                {{ $t('dash.post-creator.form.facebook.link-preview') }}
                <i class="fa-solid fa-caret-down"></i>
            </summary>

            <div class="content-detail">
                <div class="list-thubmmail">
             
                    <div class="thubmmail" v-for="(url) in draftInstance.form.urlsTextContentHistory.items" @click="()=>selectUrl(url.value)" :key="url.value">
                        <Checkbox :id="url.value" :prefixId="'thubmmail-'" 
                            :isChecked="(draftInstance.form.networks.facebook.snippet.link == url.value)" 
                            :isDisable="(draftInstance.form.networks.facebook.snippet.link == url.value)"
                            :add="() => selectUrl(url.value)" :remove="()=>{}">
                        </Checkbox>
                        <SnippetNetwork 
                            :link="url.value"
                            :imageUrlDefault="draftInstance.form.networks.facebook.snippet.imageUrl ? draftInstance.form.networks.facebook.snippet.imageUrl : undefined" 
                            :titleDefault="draftInstance.form.networks.facebook.snippet.title ? draftInstance.form.networks.facebook.snippet.title : undefined" 
                            :descriptionDefault="draftInstance.form.networks.facebook.snippet.description ? draftInstance.form.networks.facebook.snippet.description : undefined">
                        </SnippetNetwork>
                    </div>
                </div>
                <!-- <div class="type-switch">
                    Apporter des modifications à l'aperçu du lien
                    <ComponentSwitch :value="inputModel.switchCustomSnippet" :onChange="(v)=> inputModel.switchCustomSnippet = v" :id="'switch-settings-advanced-facebook-2'"></ComponentSwitch>
                </div>
            
                <template v-if="inputModel.switchCustomSnippet">
                    <div class="type-btn-add">
                        <i class="fa-solid fa-image" @click="()=> formDataNetwork.snippet.imageUrl = '' "></i>
                        Ajouter une image
                        <i class="fa-solid fa-plus" @click="()=> formDataNetwork.snippet.imageUrl ='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4Xuh673slO7MDTuB8cYoOSpnbSUc7OyKwrA&s'"></i>
                    </div>
                    <div class="type-input">
                        <i class="fa-solid fa-pen-to-square"></i>
                        <input placeholder="Titre par default" v-model="formDataNetwork.snippet.title">
                        <i class="fa-regular fa-square-minus" v-if="formDataNetwork.snippet.title" @click="()=> formDataNetwork.snippet.title =''"></i>
                    </div>
                    <div class="type-input">
                        <i class="fa-solid fa-pen-to-square"></i>
                        <input placeholder="Description par default" v-model="formDataNetwork.snippet.description">
                        <i class="fa-regular fa-square-minus" v-if="formDataNetwork.snippet.title" @click="()=> formDataNetwork.snippet.description =''"></i>
                    </div>
                </template> -->
            </div>
            
        </details>
        <!-- <details open v-if="formDataNetwork.typeMedia == 'video'">
            <summary>Format <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="list-radio-btn">
                    <div class="type-btn-simple" @click="setIsReel(false)">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : !formDataNetwork.isReel}"></i>
                        <p>Vidéo</p>
                    </div>

                    <div class="type-btn-simple" @click="setIsReel(true)">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : formDataNetwork.isReel}"></i>
                        <p>Réel</p>
                    </div>
                </div>  
            </div>      
        </details> -->
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from '@/store/index.js';
    import ComponentSwitch from '@/components/dash/utils/switch.vue'
    import SelectComponent from '@/components/dash/utils/select.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '@/components/mixins/Bots.vue'
    import minxinPost from '@/components/mixins/Posts.vue'
    import Checkbox from '@/components/dash/utils/checkbox.vue'


    import { VueDraft } from '@mashupweb/draft-lib'
    export default {

        components: {
            ComponentSwitch,
            SelectComponent,
            SnippetNetwork,
            Checkbox
        },
        mixins: [minxinBot,minxinPost],

        props: {
            hide : {
                type: Boolean,
                default: false
            },
            files:Object,
            draftInstance:VueDraft
           
        },
        
        data() {
            return {
                inputModel:{
                    switchCustomSnippet: false,
                    urlImageSnippet: "",
                    titleSnippet: "",
                    descriptionSnippet: "",
                },

                lastModeSelected : undefined
            }
        },

        created () {

        },

        mounted() {
            EventBus.$on('eventSearchFromSelectPlace', this.searchPlace);
            EventBus.$on('eventClickSelectPlace', this.addPlace);
            EventBus.$on('eventRemoveSelectPlace', this.removePlace);
        },

        methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },

            changeVisibilityPost(state) {
                this.draftInstance.form.networks.facebook.visibility = state
            },

            selectUrl(url) {
                if (this.draftInstance.form.networks.facebook.snippet.link == url) {
                    this.draftInstance.form.networks.facebook.snippet.unselect()
                }else{
                        this.draftInstance.form.networks.facebook.snippet.select(url)
                }
            },

            async searchPlace(network, value,idEvent) {
                console.log("searchPlace facebook")
                if (network !== 'facebook') return
                let page = this.pagesSelected.find(p => p.network == "facebook" && p.bot_status)
                
                let result = []
                if (page) {
                    try {
                        result = (await this.getLocation(page.id, value)).body.locations
                    } catch (error) {
                        console.error("impossible de recuperer les lieux facebook", error)
                    }
                }
                EventBus.$emit("resultSearchFromSelectPlace", result, idEvent)
            },

            addPlace(network, place) {
                if (network !== 'facebook') return
                this.draftInstance.form.networks.facebook.place = place
            },

            removePlace(network) {
                if (network !== 'facebook') return
                this.draftInstance.form.networks.facebook.place = undefined
            },

            setIsReel(isReel) {
                this.draftInstance.form.networks.facebook.isReel = isReel
            }
        },


       

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
            pagesSelectedIncludeConciergerie() {
                return this.pagesSelected.filter(page => page.network == 'facebook' && page.story_config && page.story_config.created).length
            },
            hasPersonalConciergeriePage() {
                return this.pagesSelected.some(page =>
                    page.network == 'facebook'
                    && page.story_config && page.story_config.created
                    && !(page.bots && page.bots[0] && page.bots[0].page && page.bots[0].page.story_config && page.bots[0].page.story_config.i_user)
                    && !page.isGroup
                    && !page.affected_to
                )
            },
        },


        beforeDestroy () {
            EventBus.$off('eventSearchFromSelectPlace', this.searchPlace);
            EventBus.$off('eventClickSelectPlace', this.addPlace);
            EventBus.$off('eventRemoveSelectPlace', this.removePlace);
        }
        
    }
</script>